import React, { useState } from "react";

type PropTYpe = {
  onClose: () => void;
  children: React.ReactNode;
  title: string;
};

const Popup = ({ onClose, children, title }: PropTYpe) => {
  const [isClosing, setIsClosing] = useState(false);
  const handleBackgroundClick = (event: any) => {
    if (event.target === event.currentTarget) {
      handleClose();
    }
  };
  const handleClose = () => {
    setIsClosing(true);
    setTimeout(() => {
      onClose();
      setIsClosing(false);
    }, 300); // 300ms is the duration of the CSS transition
  };
  return (
    <div
      className="fixed flex flex-col w-full h-full z-[20] scrollbar-thin overflow-y-scroll scrollbar-none  bg-trans5  inset-0  transition-opacity"
      onClick={handleBackgroundClick}
    >
      {/* <div className="bg-white rounded-lg p-6 w-[50%] relative transition-transform transform  "> */}
      <div className="relative bg-white mt-auto md:my-[5%] mx-auto w-full md:w-[500px] rounded-tr-lg rounded-tl-lg md:rounded-lg">
        <div className="flex items-center justify-between w-full p-5">
          <div className="space font-semibold text-xl">{title}</div>
          <button
            className="flex items-center justify-center bg-blue text-pry font-normal p-1 rounded-sm "
            onClick={onClose}
          >
            X
          </button>
        </div>
        {children}
      </div>
    </div>
  );
};

export default Popup;
